import createRouter from "./createRouter";
import LayoutContainer from "@/views/Layout/LayoutContainer.vue";

export const routes = [
  {
    path: '/line',
    redirect: '/line/message',
    component: LayoutContainer,
    children: [
      {
        path: 'message',
        name: 'LineMessage',
        component: () => import('@/views/Line/LineMessage.vue'),
        meta: {
          title: '专线管理-短信'
        }
      }
    ]
  }
]

export default createRouter(routes)